import { Typography } from "@mui/material";

import ProductsMenu from "@/components/ProductsMenu";
import SimpleBar from "@/components/third-party/SimpleBar";
import useUserData from "@/hooks/useUserData";
import Profile from "@/layouts/MainLayout/Drawer/DrawerContent/Profile";
import { useSelector } from "@/main-store/hooks";
import menuItems from "@/menu-items";

// project import
import Navigation from "./Navigation";

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { userProfile } = useUserData();
  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <>
      <SimpleBar
        sx={{
          pl: drawerOpen ? "12px" : "8px",
          // Match the left inset when open so the selected item's drop shadow has
          // room on the right — the SimpleBar mask clips overflow, so pr:0 cropped it.
          pr: drawerOpen ? "12px" : "0px",
          "& .simplebar-content": {
            display: "flex",
            flexDirection: "column",
          },
          flexGrow: 1,
        }}
      >
        {drawerOpen && (
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "22px",
              textTransform: "uppercase",
              px: 2.5,
              pt: "24px",
              pb: "6px",
              color: "text.secondary",
            }}
          >
            Account
          </Typography>
        )}
        <ProductsMenu
          drawerOpen={drawerOpen}
          productName={userProfile?.companyName}
          productIconLink={userProfile?.avatar}
          disableSelect
        />
        <Navigation drawerOpen={drawerOpen} menuItems={menuItems} />
      </SimpleBar>
      <Profile drawerOpen={drawerOpen} />
    </>
  );
};

export default DrawerContent;
